import { Component, Fragment } from 'react';
import Image from 'Components/Common/Image';
import validation from 'Helpers/Validation';
import { validator } from 'Helpers/validator';
import DragUpload from 'Components/Common/Dragupload';
import LoadingOverlay from 'react-loading-overlay';
import { Link } from 'react-router-dom';
import { FILE_TYPE } from 'Helpers/apiurl';
import FileUploadWrapper from '../FileUploadWrapper';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';
import { teamConstants } from 'Constants';
import ExistedTeamUsers from '../ExistedTeamUsers';
import AddTeamUsers from '../AddTeamUsers';

export default class AddTeam extends Component {
  constructor(props) {
    super(props);
    const model = {
      teamName: '',
      aboutTeam: '',
      fileName: '',
      isActive: 1,
      loading: false,
      image: '',
      teamMembers: [],
      searchParam: '',
      showError: false,
      errorElement: '',
      inValidFormatMeaasge: '',
      inValidFormatpopup: '',
      searchVal: '',
      showOrgError: false,
      uploadImageError: '',
      addTeamUsersPopup: false
    };
    this.state = model;
    this.validator = validator.getInstance();
  }

  /**
   * @method validation
   * @summary validate the inputs based on validation rules
   * @param {event} event - React onBlur event
   * @return {none} undefined
   */

  validation = (e) => {
    validation(e, 'add-team-form');
  };

  modifiedAddOrRemoveButton = (username) => {
    const { teamMembers } = this.state;
    const isExists = teamMembers
      ? teamMembers.findIndex((member) => member.username === username)
      : -1;
    return isExists === -1 ? 'Add' : 'Delete';
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    if(name === 'aboutTeam' && value?.length > teamConstants.ABOUT_TEAM_CHAR_LENGTH){
        return;
    } 
    this.setState({ [ name ]: value });
  };

  handleCheckBoxChange = () => {
    this.setState({ isActive: !this.state.isActive });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.totalRecords !== this.props.totalRecords) {
      if (this.props.error !== true && this.props.errorElement === '') {
        document.getElementById('searchForm') && document.getElementById('searchForm').reset();
        this.redirectToGrid();
      }
    }

    if (prevProps.errorElement !== this.props.errorElement) {
      this.setState({ errorElement: this.props.errorElement });
    }
  }

  redirectToGrid = () => {
    this.props.history.push(`/broadcast/team`);
  };

  handleAddTeamMembers = (selectedMembers) => {
    const { teamMembers } = this.state;
    let updateMembers = [ ...teamMembers ];
    updateMembers = teamMembers.concat(Object.values(selectedMembers));
    this.setState({
      teamMembers: updateMembers,
    });
  }

  handleRemoveTeamMembers = (rest) => {
    let updateMembers = [];
    const removeIndex = this.state.teamMembers
        .map((item) => {
          return item.username;
        })
        .indexOf(rest.username);
    if(removeIndex > -1){
        this.state.teamMembers.splice(removeIndex, 1);
        updateMembers = this.state.teamMembers;
        this.setState({
          teamMembers: updateMembers,
        });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const id = 'add-team-form';
    const { teamName, aboutTeam, isActive, image, teamMembers } = this.state;
    const teamUsers = teamMembers.map((item) => {
      return item[ 'username' ];
    });
    this.setState({ 
      uploadImageError: image === '' ? 'Please upload image' : ''
    }, ()=>{
      if (teamUsers.length === 0) {
        if (
          !this.validator.checkBeforeSubmit(id) &&
          this.state.showError !== true &&
          this.state.uploadImageError === ''
        ) {
          this.props.addTeam(
            {
              teamName: teamName,
              aboutTeam,
              isActive,
              image,
              teamMembers: teamUsers
            },
            this.props.filterVal
          );
        }
      } else {
        if (
          !this.validator.checkBeforeSubmit(id) &&
          this.state.showError !== true &&
          this.state.uploadImageError === ''
        ) {
          this.props.addTeam(
            {
              teamName: teamName,
              aboutTeam,
              isActive,
              image,
              teamMembers: teamUsers
            },
            this.props.filterVal
          );
        }
      }
    });
  };

  updateImage = (fileToken, fileName) => {
    this.setState({
      image: fileToken,
      fileName,
      uploadImageError:''
    });
  };
  handleimageError = (error, message) => {
    this.setState({ inValidFormatpopup: error, inValidFormatMeaasge: message });
  };
  handleInValidPopup = () => {
    this.setState({ inValidFormatpopup: false });
  };

  removeProfileimage = () => {
    this.setState({
      image: '',
      fileName: '',
    });
  };

  forceUpdateHandler(){
    this.forceUpdate();
  };

  toggleAddTeamUsersPopup = () => {
    this.setState( { addTeamUsersPopup: !this.state.addTeamUsersPopup } );
  }

  render() {
    const {
      teamName,
      aboutTeam,
      image,
      inValidFormatMeaasge,
      inValidFormatpopup,
      uploadImageError,
    } = this.state;
    const {
      usersTotalRecords,
      usersCurrentPage,
      formLoading,
    } = this.props;
    return (
      <Fragment>
        <div className='pageContainer_inner pb-15'>
          <LoadingOverlay
            active={ formLoading }
            spinner
            styles={ {
              wrapper: {
                width: '100%',
                textAlign: '-webkit-center',
              },
            } }
            text='Please wait...'
          ></LoadingOverlay>
          <div className='myprofile'>
            <div className='heading-block gap-10'>
              <div className='block_flex'><h4>New Team Broadcast</h4></div>
            </div>
            <div className='main-block loading-parent p-0'>
              <form id='add-team-form'>
                <div className='pageContent'>
                  <div>
                    <div className='ctInputField'>
                      <label>
                        Team Name<sup>*</sup>
                      </label>
                      <input
                        type='text'
                        name='teamName'
                        className='team-ipout'
                        value={ teamName }
                        data-validation={ [ 'requiredfield' ] }
                        placeholder='Enter team name here!'
                        data-error='Enter team name'
                        onBlur={ this.validation }
                        maxLength='25'
                        onChange={ this.handleChange }
                      />
                    </div>
                    <div className='ctInputField'>
                      <label>About Team</label>
                      <input
                        type='text'
                        name='aboutTeam'
                        className='team-ipout'
                        value={ aboutTeam }
                        placeholder={ `Enter about team here!` }
                        onChange={ this.handleChange }
                        maxLength={ teamConstants.ABOUT_TEAM_CHAR_LENGTH }
                      />
                      <p className='ctCharText'>{ `${ aboutTeam?.length || 0 }/${ teamConstants.ABOUT_TEAM_CHAR_LENGTH } Characters` }</p>
                    </div>
                    <div className='ctInputField'>
                      <label>Profile image<sup>*</sup></label>
                      <div className='profile-img-block'>
                        <div className='profile-image'>
                          <Image imageToken={ image } />
                        </div>
                        <DragUpload
                            id='addadminupload'
                            removeImage={ this.removeProfileimage }
                            updateImage={ this.updateImage }
                            requiredfield='requiredfield'
                            imageError={ this.handleimageError }
                            type= { FILE_TYPE.IMAGE }
                            uploadImageError = { uploadImageError }
                            inputTypeFileComp = { ( { fileInputProps } ) => { return <FileUploadWrapper fileInputProps={ fileInputProps } /> } }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <ExistedTeamUsers 
                usersList={ this.props.usersList }
                usersCurrentPage={ usersCurrentPage }
                teamMembers={ this.state.teamMembers }
                handleRemoveTeamMembers = { this.handleRemoveTeamMembers }
                toggleAddTeamUsersPopup = { this.toggleAddTeamUsersPopup }
                addTeamUsersPopup = { this.state.addTeamUsersPopup }
              />
              <div className='button_fixed_block'>
                <div>
                  <button
                    type='reset'
                    onClick={ this.redirectToGrid }
                    className='btn btn_outline'
                  >
                    Cancel
                  </button>
                  <button className='btn btn_primary' onClick={ this.handleSubmit }>Save</button>
                </div>
              </div>
            </div>
          </div>
          { this.state.addTeamUsersPopup && <AddTeamUsers 
            usersList={ this.props.usersList } 
            usersTotalRecords={ usersTotalRecords } 
            usersCurrentPage={ usersCurrentPage }
            teamMembers={ this.state.teamMembers } 
            fetchUsers={ this.props.fetchUsers }
            handleAddTeamMembers = { this.handleAddTeamMembers }
            toggleAddTeamUsersPopup = { this.toggleAddTeamUsersPopup }
          /> }
          {inValidFormatpopup && (
            <div className='seccess-popup'>
              <div className='content-wraper'>
                <i className='popup_close' onClick={ this.handleInValidPopup }><Close/></i>
                <p>{inValidFormatMeaasge}</p>
                <div className='action'>
                  <Link to="#" onClick={ this.handleInValidPopup } className='btn btn_primary'>ok</Link>
                </div>
              </div>
            </div>
          )}
        </div>
        <>
        </>
      </Fragment>
    );
  }
}
